import { createStore } from 'vuex'
import tab from '@/store/tab'
import user from '@/store/user'

export default createStore({
    //向外暴露对象
    modules: {
        tab,
        user
    }
})